import { render, staticRenderFns } from "./feature.vue?vue&type=template&id=8b26b66a&"
var script = {}
import style0 from "./feature.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../production/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports